import { useDispatch, useSelector } from 'react-redux';

import * as rollToActionCreators from '@makemydeal/dr-dash-store/actions/rollToActionCreators';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { ExtendedOfferTypeEnum } from '@makemydeal/dr-platform-types';

import { dealLockHooks } from '../../hooks';

const ROLL_TO_OFFER_TYPES = [
    ExtendedOfferTypeEnum.LEASE,
    ExtendedOfferTypeEnum.FINANCE,
    ExtendedOfferTypeEnum.BALLOON,
    ExtendedOfferTypeEnum.CASH
];

export const useRollToPayment = () => {
    const dispatch = useDispatch();
    const currentOfferType = useSelector(offerReduxSelectors.getCurrentOfferType) as ExtendedOfferTypeEnum;
    const isLocked = dealLockHooks.useIsDealLocked();
    const isPaymentGridOpen = useSelector((state: any) => offerReduxSelectors.getPaymentGridToggle(state, currentOfferType));

    return {
        isAvailable: ROLL_TO_OFFER_TYPES.includes(currentOfferType),
        isDisabled: isLocked || isPaymentGridOpen,
        toggle: () => dispatch(rollToActionCreators.toggleRollToPayment())
    };
};
